import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrGA: CultureInfo = {
  name: 'fr-GA',
  displayName: 'français (Gabon)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-GA',
  parent: CultureInfoFr
};
